import FacetedSearch from 'ps-components/redux/facetedSearch';
import apiClient from 'ps-components/lib/apiClient';
const nameSpace = 'LANDING_PAGE';
const RESET_LANDING_PAGE_FACET_REDUCER = 'RESET_LANDING_PAGE_FACET_REDUCER';
const initialState = {
  filtersAreOpen: false,
  facetSelection: {},
  facets: [],
  loading: false,
  loaded: false,
  error: null,
  items: [],
  query: '',
  showAddButton: true,
  resetFacetText: 'Reset Filters',
  filters: {},
  facetIsCheckedByDefault: false,
  showZeros: false,
  sortBy: 'label',
  offset: 0,
  limit: 50
};

const options = {
  apiClient,
  graphql: { apiClient },
  getInstanceState: store => store.landingPage.landingPageFacetReducer,
  useCMS: true,
  // eslint-disable-next-line no-unused-vars
  genericGridParams: state => {
    return {
      addedFilters: state.landingPage.landingPageGridReducer.addedFilters,
      excludeJobsWithZeroEmployees: state.landingPage.landingPageReducer.excludeJobsWithZeroEmployees,
      orderBy: state.landingPage.landingPageGridReducer.orderBy,
      isSlotted: false
    };
  }
};
export const landingPageJobFacetSearch = new FacetedSearch(nameSpace, initialState, options);

function extendReducer(state, action) {
  switch (action.type) {
    case RESET_LANDING_PAGE_FACET_REDUCER:
      return { ...landingPageJobFacetSearch.getInitialStateCopy(nameSpace, initialState) };
    default:
      return null;
  }
}

export const reducer = landingPageJobFacetSearch.createReducer(extendReducer, {
  searchAPI: '/cms/api/accounts/{{masterAccountId}}/org-jobs'
});

///////////////////////////////////
//           ACTIONS             //
///////////////////////////////////

export const landingPageJobFacetSearchActions = landingPageJobFacetSearch.getActions();

landingPageJobFacetSearchActions.resetLandingPageReducer = () => {
  return dispatch => {
    return dispatch({ type: RESET_LANDING_PAGE_FACET_REDUCER });
  };
};
